export default __webpack_public_path__ + "static/media/mo-img-team-advisros-jg3x.2148b684.png";